import { CardElement, CardElementProps, useElements, useStripe } from '@stripe/react-stripe-js';
import styles from './ConnectStripe.module.scss';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { StripeCardElementChangeEvent, StripeElements } from '@stripe/stripe-js';
import {
    placeHolderAxiosGuest,
    placeHolderAxiosGuestCustomer,
    setPaymentMethodAxios,
    setPaymentMethodAxiosCustomer
} from './StripeServices';

import { toastAlert } from '~/utils/toastify';
import { get } from 'lodash';
import { CartAtom } from '~/services/cart';
import OrderAtom from '~/services/order/order.atom';
import { useRouter } from 'next/router';
import { UserAddress, UserAtom } from '~/services/user';
import userAtom from '~/services/user/user.atom';
import { toast } from 'react-toastify';
import { PaymentMethods } from '~/services/payment';
import { PATH } from '~/constants/enum';
import React from 'react';

type Props = {} & CardElementProps;

export const ContentElementStrip = (props: Props) => {
    const elements: any = useElements();
    const stripe = useStripe();
    const setCart = useSetRecoilState(CartAtom.cart);
    const cart = useRecoilValue(CartAtom.cartSelector);
    const currentUser = useRecoilValue(userAtom.currentUser);
    const setOrder = useSetRecoilState(OrderAtom.order);
    // const [error, setError] = useState<any>();
    //   const [isSubmitting, setIsSumiting] = useState<any>();
    const [cardComplete, setCardComplete] = useState(false);
    const router = useRouter();

    const retrievePaymentIntent = useCallback(
        async (response: any) => {
            const message = response?.data?.message;
            if (!message) {
                toast.error(typeof message === 'string' ? message : 'Something went wrong. Please try again!');

                // setProcessing(false);
                setCart((prevCart) => ({
                    ...prevCart,
                    statusPlaceOrder: 'failed'
                }));

                return;
            }
            if (message?.includes('Authentication Required: ')) {
                const paymentIntent = message.substring('Authentication Required: '.length)?.split(',')[0];

                return stripe
                    ?.handleNextAction({
                        clientSecret: paymentIntent
                    })
                    .then((result) => {
                        if (result.error) {
                            toast.error(result.error.message);
                            setCart((prevCart) => ({
                                ...prevCart,
                                statusPlaceOrder: 'failed'
                            }));
                        } else if (result.paymentIntent) {
                            if (result.paymentIntent.status === 'succeeded') {
                                handlePlaceHolder({ cartId: cart.cartId as string });
                            } else if (result.paymentIntent.status === 'requires_confirmation') {
                                return stripe.confirmCardPayment(paymentIntent).then((confirmResult) => {
                                    if (confirmResult.error) {
                                        toast.error(confirmResult.error.message);
                                        setCart((prevCart) => ({
                                            ...prevCart,
                                            statusPlaceOrder: 'failed'
                                        }));
                                    } else {
                                        handlePlaceHolder({ cartId: cart.cartId as string });
                                    }
                                });
                            } else {
                                toast.error('Payment failed. Please try again.');
                                setCart((prevCart) => ({
                                    ...prevCart,
                                    statusPlaceOrder: 'failed'
                                }));
                            }
                        } else {
                            toast.error('An unexpected error occurred. Please try again.');
                            setCart((prevCart) => ({
                                ...prevCart,
                                statusPlaceOrder: 'failed'
                            }));
                        }
                    })
                    .catch((error) => {
                        console.error('Stripe handleNextAction error:', error);
                        toast.error('An error occurred while processing your payment. Please try again.');
                        setCart((prevCart) => ({
                            ...prevCart,
                            statusPlaceOrder: 'failed'
                        }));
                    });
                // return stripe?.retrievePaymentIntent(paymentIntent).then((result) => {
                //   // setProcessing(false);
                //   if (result.error) {
                //     toast.error(result?.error?.message);
                //   }
                //   if (result?.paymentIntent?.status == "requires_action") {
                //     if (result.paymentIntent.confirmation_method == "manual") {
                //       stripe?.handleCardAction(paymentIntent).then(function (result) {
                //         if (result.error) {
                //           toastAlert({ type: "error", message });
                //           setCart((prevCart) => ({
                //             ...prevCart,
                //             statusPlaceOrder: "failed",
                //           }));
                //         } else {
                //           // setProcessing(true);
                //           handlePlaceHolder({ cartId: cart.cartId as string });
                //         }
                //       });
                //     }
                //   } else {
                //     setCart((prevCart) => ({
                //       ...prevCart,
                //       statusPlaceOrder: "failed",
                //     }));
                //   }
                // });
            }
            // setProcessing(false);
            toast.error(message);
            setCart((prevCart) => ({
                ...prevCart,
                statusPlaceOrder: 'failed'
            }));
        },
        [cart.cartId, stripe]
    );

    const handleOnSuccess = (placeholderResponse: any, cart: any) => {
        toast.success('Congratulation, your order is completed');

        setCart((prevCart) => ({
            ...prevCart,
            statusPlaceOrder: 'success',
            selected_payment_method: {
                title: 'Pay by Card',
                code: PaymentMethods.STRIPE
            }
        }));
        setOrder({
            ...cart,
            order_number: placeholderResponse.order_number,
            selected_payment_method: {
                title: 'Pay by Card',
                code: PaymentMethods.STRIPE
            },
            referer: PATH.Checkout
        });
        router.push('/thank-you');
    };

    const handlePlaceHolder = async ({ cartId }: any) => {
        if (currentUser?.token) {
            return await placeHolderAxiosGuestCustomer({ cartId }, localStorage.getItem('token') as string).then(
                (response) => {
                    if (response.status !== 200) {
                        retrievePaymentIntent(response);
                    } else {
                        handleOnSuccess(get(response, 'data[0]'), cart);
                    }
                }
            );
        }

        return await placeHolderAxiosGuest({ cartId }).then((response) => {
            if (response.status != 200) {
                retrievePaymentIntent(response);
            } else {
                handleOnSuccess(get(response, 'data[0]'), cart);
            }
        });
    };

    const handleSubmit = async () => {
        // setIsSumiting(true)
        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        // if (cardComplete) {
        //     setProcessing(true);
        // }]

        const payload = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
            billing_details: {
                email: cart?.email,
                phone: cart?.billing_address?.telephone,
                name: `${cart?.billing_address?.firstname} ${cart?.billing_address?.lastname}`
            }
        });
        // setProcessing(false);
        if (payload.error) {
            // setError();
            toast.error(payload?.error.message);
            elements?.getElement('card').focus();
            setCart((prevCart) => ({
                ...prevCart,
                statusPlaceOrder: 'failed'
            }));
            // setProcessing(false);
        } else {
            try {
                const paymentMethod = payload.paymentMethod;
                const resSetPayment = !!localStorage.getItem('token')
                    ? await setPaymentMethodAxiosCustomer(
                          {
                              cartId: cart.cartId as string,
                              cc_stripejs_token: paymentMethod.id
                          },
                          localStorage.getItem('token') as string
                      )
                    : await setPaymentMethodAxios({
                          cartId: cart.cartId as string,
                          cc_stripejs_token: paymentMethod.id
                      });
                if (resSetPayment.status == 200) {
                    handlePlaceHolder({
                        cartId: cart.cartId as string
                    });
                } else {
                    // console.error(resSetPayment)
                    toast.error(resSetPayment?.data?.message || 'Something went wrong. Please try again!');
                    setCart((prevCart) => ({
                        ...prevCart,
                        statusPlaceOrder: 'failed'
                    }));

                    // setProcessing(false);
                }
            } catch (error: any) {
                toast.error(error?.message || 'Something went wrong. Please try again!');
                setCart((prevCart) => ({
                    ...prevCart,
                    statusPlaceOrder: 'failed'
                }));
            }
        }
        // setIsSumiting(false)
    };

    const handleChangeStripeInput = useCallback((event: StripeCardElementChangeEvent) => {
        // if (!!event.error) {
        setCardComplete(event.complete);
        // setError(event?.error?.message || '');
        props?.onChange?.(event);
        // }
    }, []);

    useEffect(() => {
        if (cart?.statusPlaceOrder === 'processing' && cardComplete) {
            handleSubmit();
        } else if (cart?.statusPlaceOrder === 'processing' && !cardComplete) {
            setCart((prevCart) => ({
                ...prevCart,
                statusPlaceOrder: 'failed'
            }));
        }
    }, [cart?.statusPlaceOrder]);

    return (
        <React.Fragment>
            <div className={styles.input_container}>
                <CardElement
                    className={styles.input_field}
                    {...props}
                    onChange={handleChangeStripeInput}
                    options={{
                        disableLink: true
                    }}
                />
            </div>
            {/* {<span className={"text-error"}>{error}</span>} */}
        </React.Fragment>
    );
};
